module.exports = __webpack_public_path__ + "img/northstar-1.17c9ec25.jpg";